/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupportTicketViewModel } from '../../models/support-ticket-view-model';

export interface Get$Params {
      body?: {
'id'?: number;
'markAsRead'?: boolean;
'refreshGitHub'?: boolean;
}
}

export function Get(http: HttpClient, rootUrl: string, params?: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketViewModel>> {
  const rb = new RequestBuilder(rootUrl, Get.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupportTicketViewModel>;
    })
  );
}

Get.PATH = '/api/Tickets/Get';
